<div class="c__container" id="liveChatBlock">
  <div class="c__container-info">
    <div class="c__header">
      <span class="c__label brand--h4">
        {{'chat.title' | translate}}
      </span>
      <sd-icon name="icon-chat" [size]="iconSize.xl" />
    </div>

    <button sd-button-icon
      [isSmall]="true"
      (click)="close($event)"
      [size]="iconSize.small"
      [theme]="themesEnum.invert"
      class="c__close-button"
      icon="icon-cross"
      id="liveChatClose"
    >
      <span class="is-visually-hidden">
        {{'chat.a11y.close' | translate}}
      </span>
    </button>
  </div>

  <div class="c__content is-body-s is-medium" id="liveChatCta">
    <div class="c__content-info">
      <p>{{'chat.description' | translate}}</p>
      <button sd-button
        type="button"
        id="liveChatPicto"
        (click)="onLaunchChat()"
        [theme]="themesEnum.invert"
      >
        {{'chat.cta' | translate}}
      </button>
    </div>
  </div>
</div>
